import React, { useState } from 'react';
import ReactTable from 'react-table'
import numeral from "numeral";
import moment from "moment";

const AdminPurchaseOrderTable = props => {
    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 75,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'ID SUPPLIER',
        accessor: 'name',
        Cell: ({row,original}) => supplierCell(original)
    },{
        Header: 'WAREHOUSE',
        accessor: 'name',
        Cell: ({row,original}) => warehouseCell(original)
    },{
        Header: 'PENGIRIMAN',
        accessor: 'debit',
        Cell: ({row,original}) => delveryCell(original)
    },{
        Header: 'STATUS',
        accessor: 'status',
        Cell: ({row,original}) => statusCell(original)
    },{
        Header: 'DETAIL',
        accessor: 'edit',
        Cell: ({row,original}) => editCell(original)
    }];


    const statusCell = (og) => {
        let status;
        if (og.status === 'received') {
            status = (
                <div className="text-warning">
                    <b>received</b>
                </div>
            )
        } else if (og.status === 'issued') {
            status = (
                <div className="text-danger">
                    <b>issued</b>
                </div>
            )
        } else {
            status = (
                <div className="text-success">
                    <b>stored</b>
                </div>
            )
        }
        return (
            <div>
                {status}
            </div>
        )
    };

    const supplierCell = (og) => {
        return (
            <div>
                <text>{og.supplierId}</text>
            </div>
        )
    };

    const delveryCell = (og) => {
        return (
            <div>
                <text>{moment(og.deliveryDate).format('YYYY-MM-DD HH:mm:ss')}</text>
            </div>
        )
    };

    const editCell = (og) => {
        return (
            <div>
                <button
                    className="btn btn-outline-primary mr-3 btn-sm"
                    onClick={() => window.location.href = `/admin/purchase-orders/${og.id}`}
                >
                    Lihat Detail
                </button>
            </div>
        )
    };

    const warehouseCell = (og) => {
        return (
            <div>
                <text>{og.warehouseName}</text>
            </div>
        )
    };



    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={50}
                filterable
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default AdminPurchaseOrderTable;
